export default __webpack_public_path__ + "static/media/38.4b5126f2.jpg";